import { WIDGET } from '@voltmoney/schema';
import { api } from '../../../configs/api';
import { APP_CONFIG, ConfigTokens, CreditApplicationType, getAppHeader, } from '../../../configs/config';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { ACTION, } from './types';
import { nextStepId, showLeinRemovalTrackingFlow } from '../../../configs/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { LENDER_ID } from '../../../configs/constants';
export const enhanceLimit = async (action, _datastore, { setDatastore, instrumentTrack, navigate, network, ...props }) => {
    instrumentTrack('PLEDGE_MORE_BUTTON_CLICKED', {
        source_page: 'PLEDGED_MUTUAL_FUND',
    });
    await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
        loading: true
    });
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user.linkedBorrowerAccounts[0].accountId;
    const getEnhancedAppIdResponse = await network.post(`${api.getLimitModificationApplicationForAccount}${borrowerAccountId}`, {
        creditApplicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
    }, {
        headers: await getAppHeader(),
    });
    const applicationId = getEnhancedAppIdResponse.data.applicationId;
    await AsyncStorage.setItem("application_id", applicationId);
    action.payload.applicationType === CreditApplicationType.CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES ? instrumentTrack("MARGIN_CALL_BUTTON_CLICKED") : instrumentTrack("ENHANCE_LIMIT_BUTTON_CLICKED");
    console.log('applicationType => ', action.payload.applicationType);
    const response = await network.post(`${api.getLimitModificationApplicationForAccount}${borrowerAccountId}`, {
        creditApplicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
    }, {
        headers: await getAppHeader(),
    });
    user.linkedApplications[0] = response.data;
    await SharedPropsService.setUser(user);
    const routeObj = await nextStepId(response.data.currentStepId);
    await SharedPropsService.setConfig(ConfigTokens.IS_PAN_EDIT_ALLOWED, false);
    await SharedPropsService.setConfig(ConfigTokens.IS_RTA_SWITCH_ENABLED, true);
    await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED, false);
    await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
        loading: false
    });
    // @ts-ignore
    routeObj.params.isFromManageLimit = true;
    console.warn("ROUTE OBJECT HERE IS", routeObj);
    await navigate(ROUTE.MANAGE_LIMIT_LANDING);
};
export const getURL = async (action, _datastore, { setDatastore, network, showPopup, instrumentTrack }) => {
    instrumentTrack('EMAIL_HOLDING_STATEMENT_BUTTON_CLICKED');
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    const user = await sharedPropsService.getUser();
    const accountId = user.linkedBorrowerAccounts[0].accountId;
    const response = await network.get(`${api.pdfHoldingStatement}${accountId}`, {
        headers: await getAppHeader(),
    });
    await setDatastore(action.routeId, 'manageLimit', {
        showMailLoader: false,
    });
    if (response.status === 200) {
        showPopup({
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: 'SUCCESS',
            title: 'Email sent successfully',
            subTitle: 'Account holding details have been sent to your email address.',
            ctaLabel: 'Continue',
            ctaAction: {
                type: ACTION.MENU,
                routeId: ROUTE.MANAGE_LIMIT,
                payload: {},
            },
            primary: false,
        });
    }
};
export const navigation = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack }) => {
    if (action.payload.value === 0) {
        await navigate(ROUTE.DASHBOARD);
    }
    if (action.payload.value === 1) {
        await navigate(ROUTE.TRANSACTIONS);
    }
};
export const goBack = async (action, _datastore, { navigateWithClear, goBack }) => {
    navigateWithClear(ROUTE.MANAGE_LIMIT);
};
export const navigateToUnpledege = async (action, _datastore, { navigate, goBack, removeWidgets, setDatastore }) => {
    await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
        bankData: []
    });
    await removeWidgets(ROUTE.VIEW_PORTFOLIO_DETAIL, [
        { id: "manageLimit", type: WIDGET.VIEW_PORTFOLIO }
    ]);
    navigate(ROUTE.UNPLDEGE_FUNDS);
};
export const viewDetails = async (action, _datastore, { navigate }) => {
    const collectionData = action?.payload?.value;
    const totalValueOfUnpledgedAssets = collectionData[0]?.totalValueOfUnpledgedAssets;
    if (await showLeinRemovalTrackingFlow()) {
        if (totalValueOfUnpledgedAssets) {
            await navigate(ROUTE.PLEDGE_DETAILS, {
                target: action.payload.value,
                targetDataSDK: collectionData
            });
        }
        else {
            await navigate(ROUTE.PRE_DASHBOARD_SCREEN, {
                fromRouteId: "VIEW_DETAILS"
            });
        }
    }
    else {
        navigate(ROUTE.UNPLEDGE_STATUS, { target: action.payload.value });
    }
};
let counter = 0;
export const navigateToRemovePledgeSteps = async (action, _datastore, { navigateWithClear, setDatastore, network, instrumentTrack }) => {
    instrumentTrack('REMOVE_PLEDGE_BUTTON_CLICKED', {
        source_page: 'PLEDGED_MUTUAL_FUND',
    });
    const user = await SharedPropsService.getUser();
    const extraOutstandingBufferBajaj = action?.payload?.extraOutstandingBufferBajaj;
    const extraOutstandingBufferDsp = action?.payload?.extraOutstandingBufferDsp;
    await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
        showRemovePledgeModal: false,
        showLoader: true,
        showErrorModal: false,
        counter: counter++,
    });
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
        handleFromMF: true
    };
    const creditResponse = await network
        .get(`${api.getForeclosureDetails}${user.linkedCredits[0].creditId}`, requestOptions);
    if (creditResponse?.status === 200) {
        const lenderName = user.linkedApplications[0].lenderAccountId;
        const netPayable = lenderName.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() ? creditResponse?.data?.totalDue : creditResponse?.data?.netPayable;
        const netCreditLimit = user?.linkedCredits[0]?.totalDrawingPower || 0;
        const extraBufferBajaj = (100 + extraOutstandingBufferBajaj) / 100;
        const extraBufferDsp = (100 + extraOutstandingBufferDsp) / 100;
        const bufferTotalOutstanding = lenderName.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()
            ? (netPayable * extraBufferBajaj) : lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? (netPayable * extraBufferDsp) : netPayable;
        const showUnpledgeModal = netCreditLimit < bufferTotalOutstanding ? true : false;
        await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
            showRemovePledgeModal: showUnpledgeModal,
            showLoader: false,
            showErrorModal: false,
            counter: counter++,
        });
        if (!showUnpledgeModal)
            navigateWithClear(ROUTE.REMOVE_PLEDGE_STEPS, { netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp });
    }
    else {
        await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
            showErrorModal: true,
            showLoader: false,
            showRemovePledgeModal: false,
            counter: counter++,
        });
    }
};
export const navigateToPledgeHistoryPage = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('PLEDGE_HISTORY_PAGE_VIEWED');
    navigate(ROUTE.PLEDGE_HISTORY);
};
// export const closeErrorModal: ActionFunction<CreditPayload> = async (
//     action,
//     _datastore,
//     {setDatastore},
// ): Promise<any> => {
//     await setDatastore(
//         ROUTE.VIEW_PORTFOLIO_DETAIL,
//         'manageLimit',
//         <ManageLimitProps>{
//             showErrorModal:false,
//             showLoader: false,
//             counter:counter++,
//         }
//     )
// }
